import { Component, ViewChild, ElementRef, Renderer, AfterViewInit } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map'
import { logos } from './logos';

declare let jsPDF;

@Component({
  templateUrl: './generate.component.html',
  styleUrls: ['./generate.component.scss']
})
export class GenerateComponent implements AfterViewInit {
    @ViewChild('previewPane') previewPane: ElementRef;
    private loading: boolean = true;
    private downloading: boolean = false;
    private error: string = '';
    private dataString: string = '';
    private flyerId: string = '';
    private doc: any;
    private address: string;
    private headers;
    public constructor(private router: Router, private renderer: Renderer, private route: ActivatedRoute, private http: Http) {
        let token = localStorage.getItem('amt_flyer_token');
        this.headers = new Headers();
        this.headers.append('Authorization', token);
        this.flyerId = this.route.snapshot.params['id'];
    }
    public ngAfterViewInit() {
        this.http.get(environment.endpoint + '/pdf/load/' + this.flyerId, {headers: this.headers})
            .map(res => res.json(), err => err.json())
            .subscribe(
                res => {
                    if(res.status === 'OK') {
                        let doc = new jsPDF({
                            format: 'letter'
                        });

                        doc.setFont("helvetica");
                        doc.setFontType("normal");
                        //1
                        doc.addImage(res.results.images[1], 'PNG', 5.5, 5.5, 140.45, 150.548);

                        //price & tag
                        let price = res.results.price;
                        let xOffset = ((doc.getStringUnitWidth(price) * 28) / doc.internal.scaleFactor) + 9;
                        let tagWidth = 55;
                        doc.setFillColor(108, 37, 23);
                        doc.rect(0, 13.5, xOffset+tagWidth+3, 17, 'F');
                        doc.setFillColor(255, 255, 255);
                        doc.rect(0, 14.5, xOffset+tagWidth+2, 15, 'F');

                        doc.setTextColor(113, 106, 100);
                        doc.setFontSize(28);
                        doc.text(price, 5.5, 25.5);

                        doc.setFontSize(11);
                        doc.setFontStyle('bold');
                        let splitTag = doc.splitTextToSize(res.results.tag, tagWidth);
                        let yOffset = 24;
                        if(splitTag.length > 1)
                            yOffset = 21.15;
                        doc.text(splitTag, xOffset + (tagWidth / 2), yOffset, null, null, 'center');

                        //2
                        doc.addImage(res.results.images[2], 'PNG', 148.304, 5.5, 62.281, 33.25);

                        //address
                        doc.setFontStyle('normal');
                        doc.setFillColor(108, 37, 23);
                        doc.rect(5.5, 160.133, 205.272, 22.136, 'F');
                        //Line 1
                        doc.setFontSize(19);
                        doc.setFontType('bold');
                        doc.setTextColor(255, 255, 255);
                        doc.text(res.results.address.line1, 9.196, 168.91);
                        //City State
                        doc.setFontType('normal');
                        doc.setFontSize(20);
                        doc.setTextColor(208, 200, 180);
                        doc.text(res.results.address.location, 9.196, 176.91);

                        //details
                        doc.setFillColor(113, 106, 100);
                        doc.rect(148.304, 41.306, 62.281, 114.918, 'F');

                        doc.setFontSize(25);
                        doc.setTextColor(255, 255, 255);
                        doc.setFontType('bold');
                        doc.text('DETAILS', 179.304, 50.306, null, null, 'center');

                        doc.setFontSize(17);
                        doc.setFontType('normal');
                        doc.text('MLS #' + res.results.mls, 179.304, 58.306, null, null, 'center');

                        doc.setFontSize(12);
                        let list = res.results.list;
                        let item = '';
                        let y = 65.306;
                        doc.setFillColor(255, 255, 255);
                        for(let i in list) {
                            item = list[i];
                            let splitText = doc.splitTextToSize(item, 53);
                            doc.ellipse(151.5, (y - 1.25), .75, .75, 'F');
                            doc.text(splitText, 154.304, y);
                            y = y + (5.75 * splitText.length);
                        }

                        doc.setFillColor(255, 255, 255);
                        //3
                        doc.rect(89.606, 142.305, 36.995, 36.995, 'F');
                        doc.addImage(res.results.images[3], 'JPEG', 91.606, 144.305, 32.995, 32.995);
                        //4
                        doc.rect(130.199, 142.305, 36.995, 36.995, 'F');
                        doc.addImage(res.results.images[4], 'JPEG', 132.199, 144.305, 32.995, 32.995);
                        //5
                        doc.rect(170.942 , 142.305, 36.995, 36.995, 'F');
                        doc.addImage(res.results.images[5], 'JPEG', 172.942 , 144.305, 32.995, 32.995);
                        //6
                        doc.rect(148.56, 187.476, 57.627, 39.006, 'F');
                        doc.addImage(res.results.images[6], 'JPEG', 150.56, 189.476, 53.627, 35.006);

                        //desc
                        doc.setFontSize(12);
                        doc.setFontType('normal');
                        doc.setTextColor(69, 90, 100);
                        let text = res.results.remarks;
                        let splitText = doc.splitTextToSize(text, 138.101);
                        doc.text(splitText, 6, 191.423);

                        //Page 1 logos
                        doc.addImage(logos.fairHousing, 'JPEG', 167.942, 229.616, 8.668, 9.733);
                        doc.addImage(logos.realtor, 'JPEG', 177.249, 229.582, 8.546, 9.767);
                        doc.addImage(logos.brown, 'JPEG', 153.207, 243.349, 48.307, 8.895);

                        //Page 1 URL
                        doc.setFontSize(14);
                        doc.setFontType('normal');
                        doc.setTextColor(126, 128, 131);
                        doc.text('www.AMERIMONT.com', 151.507, 259);

                        //Page 1 Address
                        doc.setFontSize(10);
                        doc.setFontType('normal');
                        doc.setTextColor(20, 20, 20);
                        doc.text('102 W MAIN STREET, SUITE A', 151.0, 265);
                        doc.text('MANHATTAN, MT 59741', 157.5, 269.5);
                        doc.text('406.284.6546', 167, 274);

                        //Agent Image
                        doc.addImage(res.results.agent.image, 'JPEG', 36.322, 239.349, 34.29, 34.29);
                        doc.setFontSize(10);
                        doc.setTextColor(126, 128, 131);
                        doc.text(doc.splitTextToSize('FOR FURTHER INFORMATION, PLEASE CONTACT', 52.306), 74.374, 243.349);
                        doc.setFontSize(16);
                        doc.text(res.results.agent.name, 74.374, 255.349);
                        doc.setFontSize(12);
                        doc.text(res.results.agent.phone.toString().replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'), 74.374, 261.349);
                        doc.text(res.results.agent.email, 74.374, 266.349);

                        doc.addPage();

                        doc.setFillColor(113, 106, 100);
                        doc.rect(5.5, 5.5, 204.9, 17.72, 'F');
                        doc.setFontSize(24);
                        doc.setTextColor(208, 200, 180);
                        doc.text('PHOTOS', 12.7, 17.289);

                        //7
                        doc.addImage(res.results.images[7], 'JPEG', 5.5, 27.093, 204.9, 112.607);
                        //8
                        doc.addImage(res.results.images[8], 'JPEG', 5.5, 143.081, 87.608, 49.761);
                        //9
                        doc.addImage(res.results.images[9], 'JPEG', 96.489, 143.081, 64.649, 49.761);
                        //10
                        doc.addImage(res.results.images[10], 'JPEG', 5.5, 196.223, 87.608, 49.761);
                        //11
                        doc.addImage(res.results.images[11], 'JPEG', 96.489, 196.223, 64.649, 49.761);
                        //12
                        doc.addImage(res.results.images[12], 'JPEG', 164.519, 143.081, 45.881, 69.744);
                        //13
                        doc.addImage(res.results.images[13], 'JPEG', 164.519, 216.206, 45.815, 29.778);

                        //Page 2 Footer
                        doc.setFillColor(113, 106, 100);
                        doc.rect(5.5, 249.365, 204.9, 24.135, 'F');
                        //Page 2 Address
                        doc.setFontSize(14);
                        doc.text('102 W Main Street, Suite A, Manhattan, MT 59741', 12.7, 266.433);
                        //Page 2 URL
                        doc.setFontSize(18);
                        doc.setTextColor(255, 255, 255);
                        doc.text('WWW.AMERIMONT.COM', 12.7, 259.855);

                        doc.addImage(logos.white, 'JPEG', 156, 256.85, 48.307, 8.895);

                        this.dataString = doc.output("dataurlstring");
                        this.previewPane.nativeElement.data = this.dataString;

                        this.doc = doc;

                    } else {
                        this.error = res.results;
                    }
                    this.loading = false;
                },
                err => { console.log(err); this.loading = false; this.error = err; }
            );
    }

    private downloadFlyer(): void {
      this.downloading = true;
        this.http.get(environment.endpoint + '/pdf/load/' + this.flyerId, {headers: this.headers})
            .map(res => res.json(), err => err.json())
            .subscribe(
                res => {
                  this.downloading = false;
                  if(res.status === 'OK') {
                    this.doc.save(res.results.address.line1 + '.pdf');
                  }
                },
                err => { console.log(err); this.loading = false; this.error = err; }
              );
    }
}



// WEBPACK FOOTER //
// ./src/app/generate/generate.component.ts